import * as React from 'react'

function useLocalStorage<T>(key: string, value: T) {
  const getItemFromLocalStorage = (key: string) => {
    const val = localStorage.getItem(key)
    if (!val) return value
    return JSON.parse(val)
  }
  const setItemToLocalStorage = React.useCallback(
    (key: string, value: T) => localStorage.setItem(key, JSON.stringify(value)),
    []
  )

  const [storedValue, setStoredValue] = React.useState<T>(() =>
    getItemFromLocalStorage(key)
  )

  React.useEffect(() => {
    setItemToLocalStorage(key, storedValue)
  }, [key, storedValue, setItemToLocalStorage])

  return [storedValue, setStoredValue] as const
}

export default useLocalStorage
